import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const PSI_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/bHCosyBLece6iwGhChuc6T/PSI_Logo_w_Outer_Ring_-_Transparent_Background.png';
export function StickyHeader() {
  const shouldReduceMotion = useReducedMotion();
  return <motion.header initial={shouldReduceMotion ? false : {
    y: -72,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    delay: 0.15,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed inset-x-0 top-0 z-50 border-b border-cyan-400/20 bg-[#050609]/95 shadow-[0_8px_24px_rgba(0,0,0,0.4)] sm:shadow-[0_10px_40px_rgba(0,0,0,0.45)] backdrop-blur-md sm:backdrop-blur-xl" data-id="element-2925" data-mp="1dso8mi1b261r">
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent" data-id="element-2926" data-mp="2czm1rryr91h" />

      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-5 sm:h-16 sm:px-6" data-id="element-2927" data-mp="877mxmk8jxfk">
        <div className="flex min-w-0 items-center gap-2.5 sm:gap-3" data-id="element-2928" data-mp="d62fvhbx32de">
          <div className="relative flex-shrink-0" data-id="element-2929" data-mp="hxkbdpv68aqz">
            <div className="absolute inset-0 rounded-full bg-cyan-400/25 blur-lg" data-id="element-2930" data-mp="i06qcake5sj8" />
            <img src={PSI_LOGO_URL} alt="Peptide Science Institute" className="relative h-10 w-10 rounded-full object-contain sm:h-12 sm:w-12" data-id="element-2931" data-mp="lz5uhsyatl9m" />
          </div>

          <div className="min-w-0 leading-none" data-id="element-2932" data-mp="3qfzvxud6pjli">
            <p className="truncate text-[11px] font-bold tracking-[0.08em] text-stone-100 sm:text-base sm:tracking-[0.12em]" style={{
            fontFamily: 'Cinzel, serif'
          }} data-id="element-2933" data-mp="3uf7ljt1a5pyp">
              Peptide Science Institute
            </p>
            <p className="mt-1 hidden text-[9px] font-semibold uppercase tracking-[0.24em] text-cyan-300/75 sm:block" data-id="element-2934" data-mp="1entfroj1san6">
              Precision Biological Intelligence
            </p>
          </div>
        </div>

        <a href="https://go.peptidescienceinstitute.com/pm-pro-monthly-fm" aria-label="Unlock access to PSI PRO" className="group flex min-h-[44px] flex-shrink-0 items-center justify-center gap-1.5 rounded-lg border border-amber-300/60 bg-amber-400 px-3 py-2 text-xs font-extrabold tracking-wide text-black shadow-[0_0_14px_rgba(251,191,36,0.28)] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:bg-amber-300 active:scale-[0.97] motion-reduce:transform-none sm:px-6 sm:text-sm sm:shadow-[0_0_22px_rgba(251,191,36,0.3)] sm:hover:scale-[1.03] sm:hover:shadow-[0_0_32px_rgba(251,191,36,0.5)]" data-id="element-2935" data-mp="36oukfje1fzwm">
          <span data-id="element-2936" data-mp="29aib2wsh2qej">Unlock PSI PRO</span>
          <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5 motion-reduce:transform-none" data-id="element-2937" data-mp="299gp3x9x4ji1" />
        </a>
      </div>
    </motion.header>;
}